import { AsyncState, Fun, IOWidget, any, async } from 'widgets-for-react'
import { UserSubscriptions } from '../../../subscription/subscriptionState'
import { fieldUpdater } from '../../../utils/updaters'
import { CollectionsLoaderState } from '../collections/collectionsLoader/collectionsLoaderState'
import { ExtendedHomeState, HomeState, homeStateUpdater } from './home.state'
import { loggedInHomeWidget } from './loggedInHome/loggedInHomeWidget'
import { loggedOutHomeWidget } from './loggedOutHome/loggedOutHomeWidget'

export const homeWidget =
  (
    loggedIn: boolean,
    userSubscriptionsState: AsyncState<UserSubscriptions>,
    collectionsLoaderState: CollectionsLoaderState,
    searchString: string,
    isSignupSuccessBannerShowing: boolean
  ): IOWidget<HomeState, Fun<HomeState, ExtendedHomeState>> =>
  (state) => {
    const homeData =
      state.homeDataState.kind == 'loaded'
        ? state.homeDataState.value
        : undefined
    return any<Fun<HomeState, ExtendedHomeState>>([
      async(state.homeDataState).map(
        fieldUpdater<HomeState>()('homeDataState')
      ),
      (loggedIn
        ? loggedInHomeWidget(
            searchString,
            userSubscriptionsState,
            collectionsLoaderState,
            isSignupSuccessBannerShowing,
            homeData
          )(state)
        : loggedOutHomeWidget(homeData)(state)
      ).map(homeStateUpdater),
    ])
  }
